<template>
  <div class="operations__wrapper" data-testid="select-step">
    <div class="operations__quantity">
      <div class="operations__quantity-container">
        <BaseText size="p5" :color="NebraskaColors.elementSecondary">
          Quantidade disponível
        </BaseText>
        <BaseText size="p5" :color="NebraskaColors.elementPrimary">
          {{ structuredOperationsSelection?.availableQuantity }}
        </BaseText>
      </div>
    </div>
    <div class="operations__select">
      <div class="operations__display-container">
        <HeadingDisplay
          title="Solicitar"
          :subtitle="structuredOperationsSelection?.title"
        />
        <InstrumentAvatar
          size="medium"
          :symbol="structuredOperationsSelection?.symbol || ''"
          :alt="structuredOperationsSelection?.symbol || ''"
        />
      </div>
      <div class="operations__buttons">
        <ButtonBoxIcon
          title="Com posição atual"
          description="Operar com o ativo que você já tem"
          type="neutral"
          icon="BB0020"
          :loading="isFetchingQuantityOperation"
          :disabled="isFetchingQuantityOperation || isFetchingValueOperation"
          @click="goToQuantityInvestment"
        />
        <ButtonBoxIcon
          title="Com nova posição"
          description="Comprar mais do ativo para operar"
          :loading="isFetchingValueOperation"
          :disabled="isFetchingQuantityOperation || isFetchingValueOperation"
          type="neutral"
          icon="EF0010"
          @click="goToValueInvestment"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { IStructuredOperationsSelection } from '@/modules/transaction/services/product-investment';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonBoxIcon,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';
import { inject, Ref, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

const route = useRoute();
const structuredOperationsSelection = inject(
  'structuredOperationsSelection'
) as Ref<IStructuredOperationsSelection>;

const isFetchingQuantityOperation = ref(false);
const isFetchingValueOperation = ref(false);

const fetchCustomOperationInfo = inject(
  'fetchProductInfo',
  (productId: string, quantity: number, useBaseAsset?: boolean) => ({
    productId,
    quantity,
    useBaseAsset
  })
);

const useBaseAssetChoice = inject('useBaseAssetChoice') as Ref<boolean | null>;

async function goToQuantityInvestment() {
  try {
    isFetchingQuantityOperation.value = true;
    useBaseAssetChoice.value = true;
    await fetchCustomOperationInfo(route.params.id, 0, true);
  } finally {
    isFetchingQuantityOperation.value = false;
  }
}

async function goToValueInvestment() {
  try {
    isFetchingValueOperation.value = true;
    useBaseAssetChoice.value = false;
    await fetchCustomOperationInfo(route.params.id, 0, false);
  } finally {
    isFetchingValueOperation.value = false;
  }
}
</script>

<style lang="less" scoped>
.operations {
  &__wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__select {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: @size-spacing-x800;
    margin-top: @size-spacing-x1000;
  }

  &__display-container {
    max-width: 492px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__quantity {
    display: flex;
    justify-content: center;
    background: @background-tertiary;
    height: @size-spacing-x1000;

    &-container {
      max-width: 492px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: @size-spacing-x400;
    width: 100%;
    max-width: 492px;
  }
}
</style>
